module.exports = __webpack_public_path__ + "static/media/onfleet-logo-grey.18fa0fc3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onfleet-logo-grey.svg
// module id = 2457
// module chunks = 0